export default {
  sm: `
  Spirit of<br> 
  DATA CENTER GAK 
  `,
};
